import { Tooltip } from '@mui/material';
import React, { useState } from 'react'
import { FcInfo } from 'react-icons/fc';
import { Col, Row } from 'reactstrap';
import { APIService } from '../../services/APIService';
import { AssistanceService } from '../../services/AssistanceService';
import ButtonComponent from '../ButtonComponent';
import InputComponent from '../InputComponent';
import { useIntl } from "react-intl";

export type PartsInsertComponentType = {
    assistanceId: number;
    setQuerySearch: React.Dispatch<React.SetStateAction<string>>;
    querySearch: string;
    setGoToPage: React.Dispatch<React.SetStateAction<number>>;
    setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
    setReloadParts: React.Dispatch<React.SetStateAction<boolean>>;
    reloadParts: boolean;
    isComplete: boolean;
    isAcceptedBudget: boolean;
}

const PartsInsertComponent = ({ assistanceId, setQuerySearch, querySearch, setGoToPage, setCurrentPage, setReloadParts, reloadParts, isComplete, isAcceptedBudget }: PartsInsertComponentType) => {

    const [showClear, setShowClear] = useState<boolean>(false);
    const [isLoadingNewExecution, setIsLoadingNewExecution] = useState<boolean>(false);
    const isLocked = isAcceptedBudget || isComplete;

    const searchOnClick = () => {
        setGoToPage(1);
        setCurrentPage(1);
        setReloadParts(!reloadParts);
        setShowClear(true);
    }

    const clearOnClick = () => {
        setQuerySearch("");
        setGoToPage(1);
        setCurrentPage(1);
        setShowClear(false);
        setReloadParts(!reloadParts);
    }

    const searchKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.code === "Enter") {
            searchOnClick()
        }
    }

    const intl = useIntl();

    return (
        <div>
            { }
            <Row style={{ marginBottom: "1rem", alignItems: "center" }}>
                <Col xl={5} lg={5} md={5} sm={12} xs={12}>
                    <Row style={{ display: "flex", alignItems: "center" }}>
                        <InputComponent xl={10} lg={10} md={12} sm={12} xs={12}
                            style={{ width: "100%" }}
                            type={"text"}
                            value={querySearch}
                            label={"Procurar Peça"}
                            readOnly={isLocked}
                            showLoadingSkeleton={isLoadingNewExecution}
                            onChange={(t: string) => {
                                setQuerySearch(t);
                                setShowClear(false);
                            }}
                            onEnter={(e) => searchKeyPress(e)}
                            autoSelectOnFocus
                        />
                        <div style={{ width: "10px", paddingTop: "20px" }}>
                            <Tooltip title={<div> Pesquisar pelo início: valor* <br /> Pesquisar pelo meio: *valor* <br /> Pesquisar pelo fim: *valor </div>} disableFocusListener enterTouchDelay={0} enterNextDelay={100} enterDelay={100} placement={"right"} style={{ cursor: "pointer" }}>
                                <b>
                                    <FcInfo className='notesIcon' fontSize={16} />
                                </b>
                            </Tooltip>
                        </div>
                    </Row>
                </Col>

                <Col xl={4} lg={4} md={4} sm={12} xs={12}>
                    {showClear === true ?
                        <ButtonComponent
                            style={{ width: '100%', marginTop: '25px' }}
                            onClick={() => {
                                clearOnClick()
                            }}
                            text={intl.formatMessage({ id: "PartInsertComponent.Clean" })}
                            loading={isLoadingNewExecution}
                            disabled={isLocked}
                        />
                        :
                        <ButtonComponent
                            style={{ width: '100%', marginTop: '25px' }}
                            onClick={() => {
                                searchOnClick()
                            }}
                            text={intl.formatMessage({ id: "PartInsertComponent.Search" })}
                            loading={isLoadingNewExecution}
                            disabled={isLocked}
                        />}
                </Col>
            </Row>
        </div>
    )
}

export default PartsInsertComponent